import Vue from "vue";
import flywhweelSFMCUtilFactory from "./flywheel-sfmc-util";
import QueryRunner from "./ad-hoc-query-runner-2";

const FlywhweelDEUtil = {
    ON_COPY_DELETE_KEYS: [
        "Client",
        "PartnerKey",
        "CreatedDate",
        "ModifiedDate",
        "ObjectID",
        "CustomerKey",
        "Name",
        "Description",
        "CategoryID",
        "Status",        
        'Template'
    ],
    copyOld: function(deSrcName, deTgtParams) {
        return this.apiCall("retrieve", {
            search_property: "Name",
            search_property_value: deSrcName,
            get_columns: true,
            single_result: true
        })
        .then(
            (response) => {
                if (response.data) {
                    this.ON_COPY_DELETE_KEYS.forEach(k => {
                        delete response.data[k];
                    });
                    if (response.data.SendableSubscriberField && response.data.SendableSubscriberField.Name) {
                        switch (response.data.SendableSubscriberField.Name.toLowerCase()) {
                            case "_emailaddress":
                                response.data.SendableSubscriberField.Name = "Email Address";
                                break;
                            case "_subscriberid":
                                response.data.SendableSubscriberField.Name = "Subscriber ID";
                                break;
                            default:
                                response.data.SendableSubscriberField.Name = "Subscriber Key";
                                break;
                        }
                    }
                    return this.apiCall(
                        "create", 
                        Vue.util.extend(
                            Vue.util.extend({}, deTgtParams),
                            {
                                properties: response.data
                            }
                        )
                    );
                } else {
                    return Promise.reject({
                        apiResponseRaw: null,
                        apiResponseMessage: "Data extension does not exist.  Cannot copy."
                    });
                }
            }
        );
    },
    normalizeDEName: function(deName) {
        deName = deName.replace(/^\s+/, '').replace(/\s+$/, '');
        if (deName.substr(0, 4).toLowerCase() == 'ent.') {
            if (!deName.substr(4, 1) != '[') {
                deName = (
                    deName.substr(0, 4) +
                    '['+
                    deName.substr(4) +
                    ']'
                );
            }
        } else if (deName.substr(0, 1) != '[') {
            deName = '['+deName+']';
        }
        return deName;
    },
    prepDEPropertiesForCreate: function(properties) {
        var fieldMap = [];
        properties = JSON.parse(JSON.stringify(properties));
        this.ON_COPY_DELETE_KEYS.forEach(k => {
            delete properties[k];
        });
        if (properties.SendableSubscriberField && properties.SendableSubscriberField.Name) {
            switch (properties.SendableSubscriberField.Name.toLowerCase()) {
                case "_emailaddress":
                    properties.SendableSubscriberField.Name = "Email Address";
                    break;
                case "_subscriberid":
                    properties.SendableSubscriberField.Name = "Subscriber ID";
                    break;
                default:
                    properties.SendableSubscriberField.Name = "Subscriber Key";
                    break;
            }
        }
        if (properties.SendableDataExtensionField && properties.SendableDataExtensionField.Name) {
            if (properties.SendableDataExtensionField.Name.substr(0, 1) == '_') {
                properties.SendableDataExtensionField.Name = `underscore${properties.SendableDataExtensionField.Name}`;
            }
        }
        properties.Fields.Field.sort((a, b) => {
            return (
                Number(a.Ordinal) == Number(b.Ordinal) ?
                0 :
                (
                    Number(a.Ordinal) < Number(b.Ordinal) ?
                    -1 :
                    1
                )
            );
        });
        properties.Fields.Field.forEach((field) => {
            if (field.Name.substr(0, 1) == '_') {
                fieldMap.push({
                    src: field.Name,
                    tgt: `underscore${field.Name}`
                });
                field.Name = `underscore${field.Name}`;
            } else {
                fieldMap.push({
                    src: field.Name,
                    tgt: field.Name
                });
            }
        });
        return Promise.resolve({
            fieldMap,
            properties: properties
        });
    },
    getDEPropertiesForCreate: function(deSrcName, categoryId, isEnt) {
        var filter;
        isEnt = (typeof isEnt == 'undefined') ? false : isEnt;
        if (String(categoryId).match(/^[0-9]+$/)) {
            filter = this.complexFilter(
                this.simpleFilter(
                    'Name',
                    deSrcName
                ),
                'AND',
                this.simpleFilter(
                    'CategoryID',
                    categoryId
                )
            );
        } else {
            filter = this.simpleFilter(
                'Name',
                deSrcName
            );
        }
        return this.apiCall("retrieve", {
            complex_filter: filter,
            get_columns: true,
            single_result: true,
            query_all_accounts: isEnt || String(categoryId).match(/^[0-9]+$/)
        }).then(
            (response) => {
                if (response.data) {
                    return this.prepDEPropertiesForCreate(response.data);
                } else {
                    return Promise.reject({
                        apiResponseRaw: null,
                        apiResponseMessage: "Data extension does not exist.  Cannot copy."
                    });
                }
            }
        );
    },
    setDataRetentionToProperties: function(propertiesTgt, propertiesDataRetention) {
    /*
        e.g. 
        propertiesDataRetention = {
            DataRetentionPeriod: "Days",
            DataRetentionPeriodLength: String(retentionInDays),
            DeleteAtEndOfRetentionPeriod: "false"
        }
    */
       propertiesTgt = JSON.parse(JSON.stringify(propertiesTgt));
        ([
            'DataRetentionPeriod',
            'DataRetentionPeriodLength',
            'DataRetentionPeriodUnitOfMeasure',
            'DeleteAtEndOfRetentionPeriod',
            'ResetRetentionPeriodOnImport',
            'RetainUntil',
            'RowBasedRetention'
        ]).forEach((k) => {
            delete propertiesTgt[k];
        });
        return {
            ...propertiesTgt,
            ...propertiesDataRetention
        };
    },
    copy: function(deSrcName, propertiesTgt, srcTgtFieldMap, deTgtName, deTgtPath, processStatus) {
        //console.log(JSON.stringify(arguments, null, 4));
        return this.apiCall("retrieve", {
            search_property: "Name",
            search_property_value: deTgtName,
            single_result: true
        }).then(
            (response) => {
                if (response.data) {
                    processStatus.error(`Target data extension '${deTgtName}' already exists.  Please choose a new name or delete the existing.`);
                    return Promise.reject(`Target data extension '${deTgtName}' already exists.  Please choose a new name or delete the existing.`);
                } else {
                    return Promise.resolve();
                }
            }
        ).then(
            // Create target DE
            () => this.apiCall(
                "create",
                {
                    name: deTgtName,
                    path: deTgtPath,
                    properties: propertiesTgt
                }
            )
        ).then(
            () => {
                var selectList = [];
                if (srcTgtFieldMap) {
                    srcTgtFieldMap.forEach((map) => {
                        selectList.push(`src.[${map.src}] as [${map.tgt}]`);
                    });
                } else {
                    propertiesTgt.Fields.Field.forEach((field) => {
                        selectList.push(`src.[${field.Name}] as [${field.Name}]`);
                    });
                }
                var queryRunner = new QueryRunner(
                    this.component,
                    `select ${selectList.join(',')} from ${this.normalizeDEName(deSrcName)} as src`,
                    {
                        tgtDEName: deTgtName,
                        autoDeleteDE: false,
                        responseRender: QueryRunner.RESPONSE_IGNORE
                    },
                    processStatus
                );

                return queryRunner.run().then(
                    () => {
                        processStatus.state = QueryRunner.STATE_IDLE;
                        return Promise.resolve(queryRunner);
                    },
                    (error) => {
                        processStatus.state = QueryRunner.STATE_ERROR;
                        processStatus.error(
                            error.apiResponseMessage,
                            error.apiResponseRaw
                        );
                        return Promise.reject(error.apiResponseMessage);
                    }
                );
            }
        );
    },
    rowCount: function(deName, component) {
        return import('./ad-hoc-query-runner-2.js').then(
            ({ QueryRunner }) => {
                var queryRunner = new QueryRunner(
                    component,
                    `select count(*) as count_rows from [${deName}]`,
                    {
                        delimiter: QueryRunner.delimiters.json
                    }
                );
                return queryRunner.run();
            }
        ).then(
            (queryResultRows) => Promise.resolve(parseInt(JSON.parse(queryResultRows)[0]['count_rows']))
        );
    }
};

export default function(component) {
    var flywheelDEUtil = flywhweelSFMCUtilFactory(component, "de");
    Vue.util.extend(
        flywheelDEUtil,
        FlywhweelDEUtil
    )
    return flywheelDEUtil;
}